import styled from 'styled-components';

export const StyledTableWrapper = styled.div`
    .ant-pagination {
        margin-bottom: 0px;
    }
`;
